import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';

export function getRenewalEffectiveDateOptions(): OptionType[] {
  const now = new Date();
  now.setDate(1);
  const options = Array.from({ length: 16 }).map((_, index) => {
    const date = new Date(now);
    date.setMonth(date.getMonth() - 3 + index);
    const month = date.toLocaleString('en-US', { month: 'long' });
    return {
      value: date.toISOString().slice(0, 10),
      label: `${month} 1, ${date.getFullYear()}`,
    };
  });

  return options;
}
